import PropTypes from 'prop-types'
import React, { Component } from 'react'

import Link from 'base/react/components/link'
import FacebookConnectButton from 'base/react/components/facebook_connect_button'
import GoogleConnectButton from 'base/react/components/google_connect_button'

export const SocialTypes = {
  FACEBOOK: 'Facebook',
  GOOGLE: 'Google',
}

export default class SocialSignInForm extends Component {
  static propTypes = {
    socialType: PropTypes.oneOf(Object.values(SocialTypes)).isRequired,
    onClickSignIn: PropTypes.func.isRequired,
    onClickResetPassword: PropTypes.func.isRequired,
    siteLocation: PropTypes.string.isRequired,
    className: PropTypes.string,
    onSocialSuccess: PropTypes.func,
    onSocialFailure: PropTypes.func,
  }

  renderFacebookButton() {
    return (
      <FacebookConnectButton
        showIcon
        onSuccess={this.props.onSocialSuccess}
        onError={this.props.onSocialFailure}
        siteLocation={this.props.siteLocation}
        className="login__social-button flat-button--full-width"
      >
        Log in with Facebook
      </FacebookConnectButton>
    )
  }

  renderGoogleButton() {
    return (
      <GoogleConnectButton
        showIcon
        onSuccess={this.props.onSocialSuccess}
        onError={this.props.onSocialFailure}
        siteLocation={this.props.siteLocation}
        className="login__social-button flat-button--full-width"
      >
        Log in with Google
      </GoogleConnectButton>
    )
  }

  render() {
    const { socialType, onClickSignIn, onClickResetPassword, className } = this.props
    return (
      <div className={className}>
        <p className="social-sign-in-form__message">
          {`Your email address is connected to ${socialType}.`}
          <br />
          {`Log in with ${socialType} to continue.`}
        </p>
        {socialType === SocialTypes.FACEBOOK && this.renderFacebookButton()}
        {socialType === SocialTypes.GOOGLE && this.renderGoogleButton()}
        <Link className="social-sign-in-form__link" onClick={onClickSignIn}>
          Don&rsquo;t have an account?
          <span>Sign Up</span>.
        </Link>
        <Link className="social-sign-in-form__link" onClick={onClickResetPassword}>
          Want to log in with email?
          <span>Reset Password</span>.
        </Link>
      </div>
    )
  }
}
